import { typographyBody1 } from 'lib/core';
import { css } from 'styled-components';

export const tablePaginationTextStyles = css`
  ${({ theme }) => typographyBody1(theme)};
  color: ${({ theme }) => theme.color.text.light.secondary.value};
`;
